import { useTranslation } from 'react-i18next';
import { Icon } from '@socialchorus/shared-ui-components';
import {
  MAXIMUM_TITLE_LENGTH,
  useUserGeneratedContent,
} from '../../../../models/user-generated-contents/context';
import { ReferenceTextInput } from '../../../../components/ui/reference-text-input';
import { useFeatureFlag } from '../../../../common/use-feature-flag';
import { Feature } from '../../../../models/features/features';
import '../form.scss';

const TITLE_ERROR_ID = 'ugc-title-error';

const TitleInput = () => {
  const {
    userGeneratedContent,
    isPersisting,
    updateUserGeneratedContentFormState,
    memberValidationErrors,
  } = useUserGeneratedContent();
  const { t } = useTranslation();
  const mentionsEnabled = !!useFeatureFlag(Feature.TAG_USER_ENABLED);

  const onTextChange = (title: string) => {
    updateUserGeneratedContentFormState({ title });
  };

  const showError = memberValidationErrors.title;

  return (
    <div className="ugc__editor-input-wrapper ugc__editor-input-wrapper-title">
      <ReferenceTextInput
        mentionsEnabled={mentionsEnabled}
        placeholder={t('user_generated_content.field_title_placeholder')}
        fullWidth
        value={userGeneratedContent.title || ''}
        onChange={onTextChange}
        disabled={isPersisting}
        className={'ugc__title-input-fieldset'}
        maxLength={MAXIMUM_TITLE_LENGTH}
        allowExceedingMaxLength
        inputClassName={'ugc__title-input'}
        variant="borderless"
        aria-label={t('user_generated_content.field_title')}
        aria-invalid={showError || undefined}
        aria-describedby={showError ? TITLE_ERROR_ID : undefined}
        aria-errormessage={showError ? TITLE_ERROR_ID : undefined}
        showCharacterCounter
      />
      {showError && (
        <div id={TITLE_ERROR_ID} role="alert" className="ugc__validation-error">
          <Icon size={16}>warning</Icon>
          <span className="text-caption">
            {t('user_generated_content.validation.title_required')}
          </span>
        </div>
      )}
    </div>
  );
};

export default TitleInput;
